import ApiHandler from "./ApiHandler";

const OAuthRefreshToken = {
  postRefresh: async (data) => await ApiHandler.i.post(`/oauth/refresh-token/refresh`, data),
};

export default OAuthRefreshToken;